<template>
  <div class="content naturezas p-1">
    <h4 class="naturezas_title">
      <b>Natureza Protocolo</b>
    </h4>

    <div class="pl-3 pr-3">
      <b-row align-h="between">
        <div class="ml-3 mt-1 col-4 p-0">
          <div class="form-group">
            <label for="busca"
                   class="natureza_label">Buscar natureza</label>
            <input id="busca_natureza"
                   ref="busca_natureza"
                   v-model="search"
                   class="col-md-12 form-control form-control-sm"
                   name="busca_natureza"
                   placeholder="Digite o nome da natureza"
                   type="text">
          </div>
        </div>
        <div>
          <div class="mt-3 mr-3">
            <b-button ref="natureza_add"
                      variant="secondary"
                      size="sm"
                      @click="showModal()">
              <svg class="button_add_icon icon--xxs"
                   role="presentation">
                <use :xlink:href="'#' + add.id" />
              </svg>
              Adicionar natureza
            </b-button>
          </div>
        </div>
      </b-row>
      <Table
        :fields="fields"
        :data="naturezas"
        :is-busy="isBusy"
        :search="search"
        field-search="descricao"
        @showModal="showModal"
        @deleteItem="deleteNatureza"
        @onUpdateAtivo="updateAtivo" />

      <Pagination
        :per-page="perPage"
        :page="page"
        :last-page="lastPage"
        @onPreviousPage="previousPage"
        @onNextPage="nextPage" />


      <b-modal
        id="modal-cadastro"
        no-close-on-backdrop
        no-close-on-esc
        size="lg"
        class="no-padding"
        hide-header>
        <div class="col-12">
          <div class="row align-items-center">
            <div
              role="group"
              class="col-12 form-group">
              <label
                for="input-live"
                class="label">Descrição</label>
              <b-form-textarea
                v-model="form.descricao"
                placeholder="Insira a descrição"
                rows="4"
                no-resize />
            </div>
          </div>
        </div>
        <template v-slot:modal-footer>
          <form autocomplete="off"
                class="no-padding"
                @submit.prevent="callMethod()">
            <div class="w-100">
              <b-row align-h="end">
                <b-button
                  size="sm"
                  class="btn btn-sm btn_voltar"
                  variant="outline"
                  @click="$bvModal.hide('modal-cadastro')">
                  Voltar
                </b-button>
                <b-button
                  size="sm"
                  type="submit"
                  class="mr-3"
                  :disabled="!form.descricao">
                  {{ form.editar ? "Atualizar" : "Adicionar" }}
                </b-button>
              </b-row>
            </div>
          </form>
        </template>
      </b-modal>
    </div>
  </div>
</template>
<script>
  /* components */
  import Table from '@/components/SofiaRei/Table'
  import Pagination from '@/components/SofiaRei/Pagination'

  /* services  */
  import NaturezaProtocoloService from "@/services/NaturezaProtocoloService"

  /* assets */
  import add from '@/assets/icons/add.svg?sprite'
  import editIcon from "@/assets/icons/pencil.svg?sprite"
  import trash from "@/assets/icons/trash.svg?sprite"
  import eyeIcon from "@/assets/icons/eye.svg?sprite"

  /* outros */
  import _ from 'lodash'
  import { mapGetters } from 'vuex'

  export default {
    name: 'NaturezaProtocolo',
    components: {
      Table,
      Pagination,
    },
    data () {
      return {
        search: null,
        isBusy: false,
        perPage: 10,
        page: 1,
        lastPage: 1,
        add,
        editIcon,
        trash,
        eyeIcon,
        read: false,
        title: 'Nova Natureza Protocolo',
        fields: [
          {
            key: 'id',
            label: 'Ativo',
            sortable: true
          },
          {
            key: 'descricao',
            label: 'Descrição',
            sortable: true
          },
          {
            key: 'acoes2',
            label: '',
            sortable: false
          }
        ],
        naturezas: [],
        form: {
          ativo: true,
          descricao: null,
          editar: null,
        }
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      }),
    },
    watch: {
      search: function (newSearch, oldSearch) {
        this.isBusy = true
        this.viewWatch()
      }
    },
    created () {
      this.viewWatch = _.debounce(function () {
        this.searchNaturezaProtocolo()
      }, 200)
    },
    beforeMount () {
      try {
        loader({text: "Obtendo dados...", active: true})
        this.init()
      } catch (error) {
        loader({text: "", active: false})
      }
    },
    mounted () {
      this.$refs['busca_natureza'].focus()
    },
    methods: {
      async init () {
        const naturezas = await NaturezaProtocoloService.index({
          perPage: this.perPage,
          page: this.page
        })

        this.naturezas = naturezas.data
        this.lastPage = naturezas.lastPage
        this.isBusy = false

        loader({ text: "", active: false})
      },
      async showModal (natureza = { data: {}, read: false }) {
        const { data, read } = natureza
        this.read = read

        if (data.natureza_protocolo_id) {
          this.form = {
            ...this.form,
            natureza_protocolo_id: data.natureza_protocolo_id,
            descricao: data.descricao,
            ativo: data.ativo,
            editar: true,
          }
        } else {
          this.form = {
            descricao: null,
            ativo: true,
          }
        }

        this.$bvModal.show('modal-cadastro')
      },
      async callMethod () {
        this.$bvModal.hide('modal-cadastro')
        loader({ text: "Aguarde...", active: true})

        if (this.form.natureza_protocolo_id) {
          return this.update(this.form)
        } else {
          return this.store(this.form)
        }
      },
      async store (natureza) {
        try {
          const data = await NaturezaProtocoloService.store(natureza)

          if (data.natureza_protocolo_id) {
            this.init()
            await this.onSuccess('Salvo com sucesso!')
          } else {
            await this.onError('Erro ao salvar, tente novamente!')
          }
        } catch (err) {
          await this.onError('Erro ao salvar, tente novamente!')
        } finally {
          loader({ text: "", active: false})
          this.$refs['busca_natureza'].focus()
        }
      },
      async update (natureza, alert = true) {
        try {
          const data = await NaturezaProtocoloService.update(natureza.natureza_protocolo_id, natureza)

          if (data.natureza_protocolo_id) {
            if (alert) {
              this.init()
              await this.onSuccess('Editado com sucesso!')
            }
          } else {
            await this.onError('Erro ao editar, tente novamente!')
          }
        } catch (err) {
          await this.onError('Erro ao editar, tente novamente!')
        } finally {
          loader({ text: "", active: false })
          this.$refs['busca_natureza'].focus()
        }
      },
      async searchNaturezaProtocolo () {
        this.isBusy = true

        const naturezas = await NaturezaProtocoloService.index({
          perPage: this.perPage,
          page: this.page,
          descricao: this.search
        })

        this.naturezas = naturezas.data
        this.lastPage = naturezas.lastPage
        this.isBusy = false
      },
      previousPage () {
        this.isBusy = !this.isBusy
        this.page -= 1
        this.init()
      },
      nextPage () {
        this.isBusy = !this.isBusy
        this.page += 1
        this.init()
      },
      updateAtivo (data) {
        this.update(data, false)
      },
      onSuccess (title = 'Realizado com sucesso!', text = '') {
        objSwal.success.title = title
        objSwal.success.text = text
        objSwal.success.html = ''

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 300)

        return Swal.fire(objSwal.success).then((res) => {
          objSwal.success.title = ''
          objSwal.success.text = ''
          objSwal.success.html = ''

          return res
        })
      },
      onError (title = 'Erro', text = '') {
        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = ''

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 300)

        return Swal.fire(objSwal.error).then((res) => {
          objSwal.error.title = ''
          objSwal.error.text = ''
          objSwal.error.html = ''

          return res
        })
      },
      deleteNatureza (val) {
        objSwal.question.title = ''
        objSwal.question.text = 'Confirma a exclusão desta natureza?'
        objSwal.question.html = ''

        setTimeout(() => {
          const btnCancel = document.querySelector('.swal2-cancel')

          if (btnCancel) btnCancel.focus()
        }, 300)

        return Swal.fire (objSwal.question)
          .then(result => {
            if (!result.value) return

            NaturezaProtocoloService.destroy(val.natureza_protocolo_id)
              .then(async () => {
                this.init()

                await this.onSuccess('Excluída com sucesso!')

                this.$refs['busca_natureza'].focus()
              }).catch(({ message }) => {
                this.onError(`Erro ao deletar natureza.`, message)
              })
          })
      },
    }
  }

</script>
<style lang="scss">
  @import "../../scss/_utilities/_exports";

  .naturezas{
    &_title {
      background-color: $sinoreg-blue;
      color: $color-white;
      font-size: pxToRem(24);
      font-weight: 500;
      padding: pxToRem(10) pxToRem(20);
    }

    &_label {
      font-size: pxToRem(16);
    }
  }

  .button_add_icon {
    fill: white;
  }
</style>
